import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  Stack,
  Icon,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import LocationOnIcon from "@mui/icons-material/LocationOn";

export default function Geolocation({ setLatitude, setLongitude }) {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSuggestions = async (search) => {
    if (!search) {
      setSuggestions([]);
      return;
    }

    setLoading(true);
    try {
      const res = await axios.get(
        `https://nominatim.openstreetmap.org/search`,
        {
          params: {
            format: "json",
            q: search,
            addressdetails: 1,
            limit: 5,
          },
          headers: {
            "Accept-Language": "en",
          },
        }
      );
      setSuggestions(res.data);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    } finally {
      setLoading(false);
    }
  };

  // Optional debounce
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchSuggestions(query);
    }, 400);

    return () => clearTimeout(timer);
  }, [query]);

  const handleSelect = (place) => {
    setQuery(place.display_name);
    setLatitude(Number(place.lat));
    setLongitude(Number(place.lon));
    setSuggestions([]);
  };

  const handleClearClick = () => {
    setQuery("");
    setSuggestions([]);
  };

  return (
    <Box>
      <TextField
        fullWidth
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Type location"
        InputProps={{
          endAdornment: (
            <IconButton
              sx={{ visibility: query ? "visible" : "hidden" }}
              onClick={handleClearClick}
            >
              <ClearIcon />
            </IconButton>
          ),
        }}
      />

      <Box mt={1}>
        {loading && <Typography variant="caption">…loading</Typography>}

        {suggestions.map((item) => (
          <Stack
            key={item.place_id}
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              cursor: "pointer",
              p: 1,
              borderRadius: 1,
              "&:hover": {
                backgroundColor: "#F4B315",
              },
            }}
            onClick={() => handleSelect(item)}
          >
            <Icon fontSize="small">
              <LocationOnIcon />
            </Icon>
            <Typography variant="body2">
              {item.display_name}
            </Typography>
          </Stack>
        ))}
      </Box>
    </Box>
  );
}
